@if (_selectedBillOfLading) {
<div class="row">
  <div class="col-md-6">
    <div>
      <div class="card shadow-sm ">
        <div class="card-header with-border">
          Bill Of Lading
        </div>
        <div class="card-body">
          <div>
            <form #blDoc="ngForm"
              class="form-horizontal">
              <fieldset style="border: 0;"
                [disabled]="!hasRole('vessels-voyages-editor')">
                <div class="form-group row">
                  <label for="revise"
                    class="col-form-label col-md-2 ">Revise</label>
                  <div class="col-md-10">
                    <mat-checkbox
                      id="revise"
                      name="revise"
                      type="checkbox"
                      [(ngModel)]="_selectedBillOfLading.revise">
                    </mat-checkbox>
                  </div>
                </div>
                <div class="form-group row">
                  <app-material-pg-input
                    label="NO"
                    type="text"
                    name="no"
                    id="no"
                    [(ngModel)]="_selectedBillOfLading.no"
                    [required]="true">
                  </app-material-pg-input>
                </div>
                <div class="form-group row">
                  <app-material-organisation-selector
                    id="loadingPort"
                    class="pg-component"
                    [(ngModel)]="loadingPort"
                    (ngModelChange)="stsLoading($event)"
                    [organisationLanguage]="'en'"
                    name="loadingPort"
                    [organisations]="ports"
                    [placeholder]="'Loading port'"
                    [required]="true">
                  </app-material-organisation-selector>
                </div>
                @if (loadingSTS) {
                <div class="form-group row">
                  @for (sts of loadingStsVesselVoyage; track $index; let i = $index) {
                  <div>
                    <div class="row">
                      <app-material-auto-complete
                       class="col-md-6"
                        name="loadingSTSId {{i}} vessel"
                        id="loadingSTS{{i}}vessel"
                        [(ngModel)]="sts.vessel"
                        [placeholder]="'vessel STS from'"
                        [formatter]="vesselFormatter"
                        (ngModelChange)="getAllVesselVoyages($event, i)"
                        #name="ngModel"
                        [items]="vessels"
                        [required]="true">
                      </app-material-auto-complete>
                        <app-material-auto-complete
                          class="col-md-6"
                          name="loadingSTSId{{i}}voyage"
                          id="loadingSTS{{i}}voyage"
                          [placeholder]="'voyage STS from'"
                          [(ngModel)]="sts.voyage"
                          [items]="sts.voyages"
                          [formatter]="voyageFormatter"
                          [required]="true">
                        </app-material-auto-complete>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6">
                        @if (loadingStsVesselVoyage.length > 1) {
                        <app-material-pg-button
                          (clicked)="removeLoadingSTS(i)"
                          label="Remove STS"
                          class="d-flex justify-content-start">
                        </app-material-pg-button>
                        }
                      </div>
                      @if (loadingSTS) {
                      <div class="col-md-6">
                        <app-material-pg-button
                          (clicked)="addLoadingSTS()"
                          label="New loading STS">
                        </app-material-pg-button>
                      </div>
                      }
                    </div>
                  </div>
                  }
                </div>
                }
                <div class="form-group row">
                  <app-material-date-range
                    id="billOfLadingDate"
                    [singleDateSelector]="true"
                    [(dateRange)]="selectedDate"
                    [disabled]="!loadingPort">
                  </app-material-date-range>
                </div>
                <div class="form-group row">
                  <app-material-organisation-selector
                    class="pg-component"
                    [(ngModel)]="shipper"
                    [organisationLanguage]="'en'"
                    name="shippers"
                    [placeholder]="'Shipper'"
                    [organisations]="shippers"
                    [required]="true">
                  </app-material-organisation-selector>
                </div>
                <div class="form-group row">
                  <app-material-organisation-selector
                    class="pg-component"
                    [(ngModel)]="consignee"
                    [organisationLanguage]="'en'"
                    name="consignees"
                    [organisations]="consignees"
                    [placeholder]="'Consignee'"
                    [required]="true">
                  </app-material-organisation-selector>
                </div>
                <div class="form-group row">
                  <app-material-organisation-selector
                    class="pg-component"
                    [(ngModel)]="agent"
                    [organisationLanguage]="'en'"
                    [placeholder]="'Agent'"
                    name="agents"
                    [organisations]="agents"
                    [required]="true">
                  </app-material-organisation-selector>
                </div>
                <div class="form-group row">
                  <app-material-organisation-selector
                    class="pg-component"
                    [(ngModel)]="notifier"
                    [organisationLanguage]="'en'"
                    [placeholder]="'Notifying'"
                    name="notifying"
                    [organisations]="notifying">
                  </app-material-organisation-selector>
                </div>
                <div class="form-group row">
                  <app-material-organisation-selector
                    class="pg-component"
                    [(ngModel)]="dischargePort"
                    id="dischargePort2"
                    name="dischargePort2"
                    [organisationLanguage]="'en'"
                    [placeholder]="'Discharge port'"
                    [organisations]="ports"
                    [required]="true">
                  </app-material-organisation-selector>
                </div>
                <div class="form-group row">
                  <app-material-chunk-file-uploader
                    [accept]="'.pdf'"
                    name="document"
                    [(ngModel)]="doc"
                    (ngModelChange)="uploadDocument($event)">
                  </app-material-chunk-file-uploader>
                </div>
                @for (product of products; track $index; let i = $index) {
                <div class="form-group row">
                    <app-material-auto-complete
                      class="col-md-6"
                      name="productNameId{{i}}"
                      id="products{{i}}"
                      [items]="productNames"
                      [formatter]="productFormatter"
                      [(ngModel)]=product.product
                      [placeholder]="'Product'"
                      #name="ngModel"
                      [required]="true">
                    </app-material-auto-complete>
                  <app-material-pg-input
                    class="col-md-6"
                    label="Weight"
                    type="number"
                    name="productNameId{{i}}.number"
                    id="products{{i}}.number"
                    [(ngModel)]=product.grossWeight
                    #name="ngModel">
                  </app-material-pg-input>
                  <div class="col-md-12">
                    @if (products.length > 1) {
                    <app-material-pg-button
                      class="pull-right btn btn-link mt-2 mb-1"
                      (clicked)="removeProduct(i)"
                      label="Remove Product">
                    </app-material-pg-button>
                    }
                  </div>
                </div>
                }
              </fieldset>
              <div class="btn-group pull-right mt-3">
                <app-material-pg-button
                  id="cancel"
                  class="me-1"
                  (clicked)="backToVoyage()"
                  label="Back to voyage">
                </app-material-pg-button>
                @if (hasRole('vessels-voyages-editor')) {
                <app-material-pg-button
                  class="pull-right  me-1"
                  (clicked)="addNewProduct()"
                  label="Add product">
                </app-material-pg-button>
                }
                @if (edit && hasRole('vessels-voyages-editor')) {
                <app-material-pg-button
                  class="pull-right me-1"
                  id="delete"
                  (clicked)="deleteBL()"
                  label="Delete">
                </app-material-pg-button>
                }
                 @if (hasRole('vessels-voyages-editor')) {
                <div>
                  <app-material-pg-button
                    class="pull-right"
                    (clicked)="saveBillOfLading()"
                    [disabled]="!blDoc.form.valid"
                    label=" Save">
                  </app-material-pg-button>
                </div>
                 }
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div>
      <app-material-pdf-viewer [fileId]="_selectedBillOfLading.fileId"> </app-material-pdf-viewer>
    </div>
  </div>
</div>
}